export default class GroupByList {
  debug = process.env.VUE_APP_DEV_DOMAIN === "true";

  list = [];

  constructor({ list }) {
    this.list = list;
  }
  groupBy(GroupByField) {
    var resultMap = new Map();

    this.list.forEach((it) => {
      let groupByValue = it[GroupByField];

      if (!resultMap.has(groupByValue)) {
        resultMap.set(groupByValue, {
          name: groupByValue,
          list: [],
        });
      }

      resultMap.get(groupByValue).list.push(it);
    });

    return [...resultMap.values()];
  }
}
